<template>
  <div class="container-fluid my-3 target">
    <div class="row" >
      <div class="col-12">
        <div class="d-flex justify-content-between">
          <div>
            <span>
              姓名: {{name}}
            </span>
            <span class="mx-3">
              班級口說平均:{{avg_score.toFixed(1)}}分
            </span>
          </div>
          <div>
            <button type="button" class="btn btn-success" @click="downloadExcel">下載報表</button>
          </div>
        </div>
      </div>
      <div class="col-12"  style="min-height:40vh">
        <table class="rwd-table">
          <tbody>
            <tr>
              <th>課程名稱</th>
              <th>最近學習日期</th>
              <th>學習時間</th>
              <th>第一次成績</th>
              <th>次數</th>
              <th>口說練習</th>
            </tr>
            <tr v-for="(item, index) in lessonList" :key="index">
              <td data-th="課程名稱" class="rwd-td">
                {{item.name}}
              </td>
              <td data-th="最近學習日期">
                {{item.recent}}
              </td>
              <td data-th="學習時間">
                {{item.time}}
              </td>
              <td data-th="第一次成績">
                {{item.first_speak_score}}
              </td>
              <td data-th="次數">
                {{item.finish_speak_count}}
              </td>
              <td data-th="最高分" v-if="item.speaking !== 'N/A'" class="pointer" style="text-decoration: underline" @click="goPage(item.course_id)">
                {{item.speaking}}
              </td>
              <td data-th="最高分" style="color:#888" v-else>
                {{item.speaking}}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
		</div>
    <pagination v-if="pageCount>1" class="m-auto pt-4" :current="pageIndex" :total="pageCount" v-on:page="toPage"/>
  </div>
</template>
<script>
// @ is an alias to /src
// import Video from '@/components/Video.vue'
import Pagination from '@/components/Pagination.vue'
import api from '../../store/api'
export default {
  name: 'StudentInfo',
  data () {
    return {
      lessonList: [],
      pageIndex: 1,
      pageCount: 0,
      pageSize: 50,
      name: '',
      avg_score: 0
    }
  },
  computed: {
    groupId () {
      return this.$route.params.groupId
    },
    studentId () {
      return this.$route.params.studentId
    }
  },
  mounted () {
    this.getStudentList()
  },
  methods: {
    async getStudentList() {
      const params = {
        page: this.pageIndex,
        pageSize: this.pageSize
      }
      const { data } = await api.get(`records/groups/${this.groupId}/voices/students/${this.studentId}`, { params })
      this.lessonList = data.data
      console.log(data)
      this.pageIndex = data.pageIndex
      this.pageCount = data.pageCount
      this.name = data.student_name
      this.avg_score = data.avg_score
    },
    formatJson (filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    },
    export2Excel (list) {
      require.ensure([], () => {
        const { export_json_to_excel } = require('../../vendor/Export2Excel')
        const tHeader = [ '課程名稱', '最近學習日期', '學習時間','第一次成績', '次數', '最高分' ]
        const filterVal = [ 'name', 'recent', 'time', 'first_speak_score', 'finish_speak_count', 'speaking' ]
        const data = this.formatJson(filterVal, list)
        export_json_to_excel(tHeader, data, '學習紀錄')
      })
    },
    async downloadExcel () {
      const params = {
        page: this.pageIndex,
        pageSize: 1000
      }
      const { data } = await api.get(`records/groups/${this.groupId}/voices/students/${this.studentId}`, { params })
      this.export2Excel(data.data)
    },
    goPage (id) {
      this.$router.push({ name: 'VoiceRecordInfo', params: { groupId: this.groupId, lessonId: id, studentId: this.studentId } })
    },
    toPage (toPage) {
      this.pageIndex = toPage
      this.getStudentList()
    }
  },
  components: {
    Pagination
  }
}
</script>
<style lang="scss" scoped>
@import "../../assets/styles/color.scss";
  table {
    border-collapse: collapse;
    width: 100%;
    overflow: auto;
  }
  th {
    overflow:hidden;
    border: 4px solid #fff;
    color: #fff;
    text-align: center !important;
    padding: 8px;
  }
  tr:nth-child(even){
    background-color:#e8e8e8 !important;
  }
  /*表格中的奇數對 tr*/
  tr:nth-child(odd){
    background-color:#d8d8d8 !important;
  }
  td {
    font-weight: bold;
    // background-color: rgb(230, 230, 230);
    border: 4px solid #fff;
    text-align: center !important;
    padding: 8px;
  }
  .th-title {
    width: 220px;
    height: 120px;
    padding: 0 !important;
    position: relative;
    img {
      top:0;
      left: -5px;
      position: absolute;
      width: 105%;
      height: 100%;
    }
  }
  .title-box {
    margin-bottom: 20px;
    border-top: #aaa solid 1px;
    border-bottom: #aaa solid 1px;
    padding: 10px 0;
    .title {
      color: #aaa;
      margin: 0 50px 0 0;
      cursor: pointer;
    }
    .active {
      color: black;
    }
  }
  .rwd-table {
    margin: auto;
    min-width: 300px;
    max-width: 100%;
    border-collapse: collapse;
}

.rwd-table tr:first-child {
  border-top: none;
  background: $table-gray !important;
  color: #fff;
}

.rwd-table tr {
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  background-color: #f5f9fc;
}

.rwd-table tr:nth-child(odd):not(:first-child) {
  background-color: #ebf3f9;
}

.rwd-table th {
  display: none;
}

.rwd-table td {
  display: block;
}

.rwd-table td:first-child {
  margin-top: .5em;
}

.rwd-table td:last-child {
  margin-bottom: .5em;
}

.rwd-table td:before {
  content: attr(data-th) ": ";
  font-weight: bold;
  width: 120px;
  display: inline-block;
  color: #000;
}

.rwd-table th,
.rwd-table td {
  text-align: left;
}

.rwd-table tr {
  border-color: #bfbfbf;
}

.rwd-table th,
.rwd-table td {
  padding: .5em 1em;
}
@media screen and (max-width: 601px) {
  .rwd-table tr:nth-child(2) {
    border-top: none;
  }
  .rwd-td {
    display: block !important;
    background-color: #04a2d6;
  }
  td {
    border: 1px solid #ccc;
  }
  button  {
    display: none;
  }
}
.lesson-box {
  width: 80%;
}
.group-box {
  width: 20%;
}
.box {
  margin: 5px;
  padding: 10px;
  background-color: #044ed6;
  color: #fff;
}
@media screen and (min-width: 600px) {
  .rwd-table tr:hover:not(:first-child) {
    background-color: #d8e7f3;
  }
  .rwd-table td:before {
    display: none;
  }
  .rwd-table th,
  .rwd-table td {
    display: table-cell;
    padding: .25em .5em;
  }
  .rwd-table th:first-child,
  .rwd-table td:first-child {
    padding-left: 0;
  }
  .rwd-table th:last-child,
  .rwd-table td:last-child {
    padding-right: 0;
  }
  .rwd-table th,
  .rwd-table td {
    // padding: 1em !important;
  }
}
</style>
